import React, { Component } from 'react'
import { GrPrice } from '../../../../utilities/helpers'
import { CartDiscountLine } from '@getgreenline/homi-shared'

interface Props {
  discount: CartDiscountLine
}

export class ParkedSaleNonBundleCartDiscountLine extends Component<Props> {
  render() {
    const { discount } = this.props
    const { discountPrice, productName } = discount
    return (
      <>
        <div
          key={`parkedSalesProductImage_${discount.discountId}`}
          className='parked-sales-modal-field-content parked-sales-item'
        >
          <div className='parked-sales-item-image'></div>
          <div className='parked-sales-item-meta'>
            <div className='parked-sales-item-meta-name'>
              <p>{productName}</p>
            </div>
          </div>
          <div className='parked-sales-item-meta-quantity'>
            {`${GrPrice.convertCentToDollar(discountPrice)} x 1`}
          </div>
          <div className='parked-sales-item-meta-out-of-stock'></div>
          <div className='parked-sales-item-meta-total'>{`${GrPrice.convertCentToDollar(
            discountPrice,
          )}`}</div>
        </div>
      </>
    )
  }
}
